var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyDraftIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1954_6831)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6917 10.425L13.4251 4.11672L1.2334 1.17505L4.17506 13.3667L10.4834 14.6334L14.6917 10.425Z",
    fill: "#E5DDF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0249 18.9157C12.1082 19.3824 10.9082 18.899 10.3665 18.0324C9.82486 17.1657 9.8582 16.024 10.2415 15.0657C10.6249 14.1074 11.2999 13.3157 12.0165 12.574C12.7749 11.7824 13.6082 11.024 14.5999 10.5657C15.5915 10.1074 16.7915 9.97404 17.7915 10.4407C18.7915 10.9074 19.4749 12.0657 19.2165 13.1324",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.89992 8.62492C9.59992 8.10825 9.28325 7.58325 8.80825 7.21659C8.33325 6.84992 7.19159 6.36659 6.66659 6.66659C6.14159 6.96659 6.19992 7.95825 6.66659 8.33325C7.09159 8.67492 8.01659 8.60825 8.26659 8.13325C8.51659 7.65825 8.40825 7.04159 8.10825 6.58325C7.80825 6.12492 7.37492 5.79159 6.94159 5.45825C4.90825 3.91659 2.86659 2.37492 0.833252 0.833252",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1954_6831"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyDraftIcon);
export default __webpack_public_path__ + "static/media/MyDraftIcon.149078f577335034b6aeeeecf1f132d7.svg";
export { ForwardRef as ReactComponent };